export default __webpack_public_path__ + "static/media/benefit-2@3x.c36662ca.png";